module.exports = __webpack_public_path__ + "lyla-and-joey-eab62f0ad98f4ed3597645c7dbeec67a.webp";